module.exports = __webpack_public_path__ + "static/media/settings.1f9e7f6f.svg";